import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import RootState from '../interfaces/root.interface';
import Order from '../interfaces/order.interface';
import VisionType from '../interfaces/vision-type.interface';
import LensPackage from '../interfaces/lens-package.interface';
import { Prescription } from '../interfaces/prescription.interface';
import helper from '../../constants/helper'

const initialState: { step: number; order: Order; isPrescription?: boolean } = {
  step: 0,
  order: {
    frame: undefined,
    lensType: undefined,
    qty: 1,
  },
  isPrescription: false
};

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setOrder: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        order: action.payload,
        step: 3
      }
    },
    setFrame: (state, action: PayloadAction<any>) => {
      return {
        ...state,
        step: 0,
        order: {
          id: helper.generateOrderId(),
          frame: action.payload,
          qty: 1,
        },
      };
    },
    setVisionNeed: (state, action: PayloadAction<VisionType>) => {
      const order = state.order;
      const step = state.step;
      let lensType = order.lensType || {};

      lensType = {
        ...lensType,
        visionType: action.payload,
      };

      return {
        ...state,
        step: action.payload.hasLens ? 2 : step,
        order: {
          ...order,
          lensType,
        },
      };
    },
    setLensPackage: (state, action: PayloadAction<LensPackage>) => {
      const order = state.order;
      let lensType = order.lensType || {};

      lensType = {
        ...lensType,
        lensPackage: action.payload,
      };

      return {
        ...state,
        step: 3,
        order: {
          ...order,
          lensType,
        },
      };
    },
    setPrescription: (state, action: PayloadAction<Prescription>) => {
      const order = state.order;
      let lensType = order.lensType || {};

      lensType = {
        ...lensType,
        prescription: action.payload,
      };

      return {
        ...state,
        order: {
          ...order,
          lensType,
        },
      };
    },
    deletePrescription: (state) => {
      const order = state.order;
      let lensType = order.lensType || {};

      lensType = {
        visionType: lensType.visionType,
        lensPackage: lensType.lensPackage,
      };

      return {
        ...state,
        order: {
          ...order,
          lensType,
        },
      };
    },
    setStep: (state, action: PayloadAction<number>) => ({ ...state, step: action.payload }),
    resetCurrentOrder: state => {
      return { ...state, ...initialState };
    },
  },

});

export const getCurrentOrder = (state: RootState) => state.currentOrder;
export const getCurrentLensType = (state: RootState) => {
  const order = state.currentOrder.order;

  return order.lensType || {};
};

export default orderSlice;
